'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.697 17.212c.189 0 .342.153.342.343v1.7h1.252v.686H4.662v-.685h1.251v-1.701c0-.19.154-.343.343-.343Zm-.343.686H6.599v1.358h3.755v-1.358Zm5.025-8.518c.19 0 .343.153.343.343v.518h1.494v-.518c0-.19.154-.343.343-.343h1.492c.19 0 .343.153.343.343v.518h.087c.664 0 1.204.54 1.204 1.203v1.915h-.686v-.719h-7.06v4.829c0 .285.232.518.518.518h.41v.685h-.41c-.664 0-1.204-.54-1.204-1.203v-6.025c0-.664.54-1.203 1.204-1.203h.087v-.518c0-.19.153-.343.343-.343Zm2.613 5.957v1.484l1.135 1.135-.323.323-1.203-1.202a.229.229 0 0 1-.067-.162v-1.578h.458Zm1.087-9.064c.19 0 .343.153.343.343v1.838c0 .189-.154.343-.343.343h-8.858l.01 7.729h-.685l-.003-1.775H7.604l1.39 1.631-.35.297-1.239-1.456.002 1.303H6.72l-.01-7.73H3.343A.343.343 0 0 1 3 8.455V6.616c0-.19.154-.343.343-.343ZM9.54 12.166l-1.918 2.128h1.92l-.002-2.128Zm-.21-.45H7.4l.003 2.138 1.927-2.137Zm5.706-1.65h-.807v.517c0 .19-.153.343-.342.343h-.43a.519.519 0 0 0-.518.518v.51h7.06v-.51a.519.519 0 0 0-.518-.518h-.43a.343.343 0 0 1-.343-.343v-.518h-.806v.518c0 .19-.154.343-.343.343h-2.18a.343.343 0 0 1-.343-.343v-.518Zm-7.639-.951.003 2.144h1.93L7.397 9.115Zm2.138-.318h-1.81l1.813 2.011-.003-2.011Zm8.112-1.522-1.094.836h2.183v-.004l-1.09-.832Zm-13.961.263v.573h.749l-.75-.573Zm11.097-.262-1.092.835h2.185l-1.093-.835Zm-2.86 0-1.093.835h2.185l-1.092-.835Zm-2.861 0-1.093.835h2.185l-1.092-.835Zm-2.86 0L5.11 8.11h2.184l-1.092-.835Zm-.338-.317H3.686v.003l1.087.832 1.091-.835Zm11.444 0h-2.186l1.093.835 1.093-.835Zm-2.863 0h-2.184l1.093.835 1.091-.835Zm-2.86 0H9.4l1.092.835 1.093-.835Zm-2.861 0H6.54l1.092.835 1.092-.835Zm10.012 0h-.75l.75.573V6.96ZM8.022 3.07a.343.343 0 0 1 .313-.053l7.189 2.321-.211.653-7.019-2.267-2.91 2.214-.415-.546Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17.354 20.126a3.24 3.24 0 0 1-2.827-3.21 3.24 3.24 0 0 1 3.66-3.209l-.09.68a2.553 2.553 0 0 0-2.884 2.528c0 1.282.957 2.37 2.227 2.53l-.086.68Z",
    fill: "#87868F"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M21 16.922a3.24 3.24 0 0 1-3.237 3.234v.841l-1.181-1.184 1.181-1.181v.839a2.553 2.553 0 0 0 2.551-2.549 2.555 2.555 0 0 0-2.55-2.55v-.687A3.24 3.24 0 0 1 21 16.922",
    fill: "currentColor"
  })));
});
var FwSet0Constructionyear3 = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Constructionyear3 = FwSet0Constructionyear3;